import { ElementType } from "react";
import {
  TailwindFontSize,
  TypographyBase,
  TypographyProps,
} from "./typography";

export type TextProps<T extends ElementType = "p"> = TypographyProps<T> & {
  size?: TailwindFontSize;
};

const Text = <T extends ElementType = "p">({
  as = "p",
  weight = "normal",
  size = "md",
  className,
  children,
  ...elementProps
}: TextProps<T>) => {
  return (
    <TypographyBase
      as={as}
      className={className}
      weight={weight}
      size={size}
      {...elementProps}
    >
      {children}
    </TypographyBase>
  );
};

export { Text };
